module.exports = __webpack_public_path__ + "static/img/2_7_2.784389d1.jpg";